import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import {Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, IconButton, Input, InputLabel, TextareaAutosize, Typography} from '@material-ui/core'
import {Container, Box, Grid} from '@material-ui/core'
import { Checkbox } from '@material-ui/core'
//FormControl InputLabel, Select, MenuItem, TextField
import {Button, TextField, OutlinedInput} from '@material-ui/core';
import { isNumber } from '../../../api/validators';
//import PersonIcon from '@material-ui/icons/Person';

import DateFnsUtils from '@date-io/date-fns';
import {MuiPickersUtilsProvider, KeyboardDateTimePicker} from '@material-ui/pickers';
import { getDateTimeFormat } from '../../../functions/lang';
import { getBase64ID } from '../../../api/helpers';
import { formatDateTime } from '../../../api/date';
import { MoreVert } from '@material-ui/icons';
import { SelectUsersDialog } from './SelectUsersDialog';


class DynamicGroupPropertiesDialog_ extends React.Component{

    constructor(props){
        super(props)

        //console.log('GroupPropertiesDialog constructor')
        //console.log('props')
        //console.log(props)

        let group = props.group ? props.group : this.getDefaults();


        this.state = {
            group: group,
            errors:{
                Name: false
            },
            changed: false,
            selectUsersDialog:{
                open: false,
                users: group.Users
            }
        }


        this.handleInput =  this.handleInput.bind(this)
        this.handleInput2 =  this.handleInput2.bind(this)
        this.handleAction = this.handleAction.bind(this)
        this.openSelectUsersDialog = this.openSelectUsersDialog.bind(this)
        this.handleDateFromChange = this.handleDateFromChange.bind(this)
    }

    getDefaults(){
        return {
            Name: '',
            ID: getBase64ID(),
            Type: 1, //dynamic
            Users: []
        }
    }

    handleSave(){
        if(this.validate()){
            let group = {...this.state.group}
            this.props.onAction({
                type: 'DYNAMIC_GROUP_PROPERTIES_DIALOG_SAVE', 
                group: group,
                networkID: this.props.networkID
            })
        }
    }

    handleDelete(){
        let group = {...this.state.group}
        this.props.onAction({
            type: 'DYNAMIC_GROUP_PROPERTIES_DIALOG_DELETE', 
            group: group,
            networkID: this.props.networkID
        })
    }

    handleClose(){
        if(this.state.changed){
            if(!window.confirm(this.props.t('CloseFormConfirm'))) return; 
        }
        this.props.onAction({type: 'DYNAMIC_GROUP_PROPETIES_DIALOG_CLOSE'})
    }

    handleInput(event){
        let changed = !this.state.changed ? {changed: true} : {}
        const val =  event.target.type==='checkbox' ? event.target.checked : event.target.value
        const group = {...this.state.group, [event.target.name]: val}
        this.setState({group: group, ...changed})
    }

    handleInput2(event){
        let changed = !this.state.changed ? {changed: true} : {}
        const val =  event.target.type==='checkbox' ? event.target.checked : event.target.value
        let state = {}
        state[event.target.name] = val

        const group = {...this.state.group}

        if(val) {
            group.DtEnd = new Date().getTime()
        }else{
            delete group.DtEnd
        }
        state.group = group

        console.log(state)
        this.setState({...state, ...changed})
    }

    handleDateEndChange(date){
        let group = {...this.state.group}
        group.DtEnd = date
        console.log('handleDateEndChange')
        console.log(date)

        this.setState({group: group})
    }

    validate(){
        const {t} = this.props

        let errors = this.state.errors;
        let error = false

        
        //if(!this.state.properties.pollingTime){
        //    errors.ChannelNum = t('ChannelNumIsEmpty')
        //    error = true
        //}else 
        /*
        if(this.state.properties.pollingEnabled && !isNumber(this.state.properties.pollingTime)){
            errors.pollingTime = t('IsNotNumber')
            error = true
        }else{
            errors.pollingTime = false
        }
/*
        if(!this.state.channel.ChannelName){
            errors.ChannelName = t('NameIsEmpty')
            error = true
        }else{
            errors.ChannelName = false
        }
        this.setState({errors: errors})
        */

        return !error;
    }

    openSelectUsersDialog(){
        let selectUsersDialog = this.state.selectUsersDialog

        selectUsersDialog.open = true
        selectUsersDialog.users = this.state.group.Users

        this.setState({selectUsersDialog: selectUsersDialog})
    }


    handleAction(action){
        switch(action.type){
            case 'SELECT_USERS_DIALOG_CLOSE':{
                let selectUsersDialog = this.state.selectUsersDialog
                selectUsersDialog.open = false
                
                this.setState({selectUsersDialog: selectUsersDialog})
                break;
            }

            case 'SELECT_USERS_DIALOG_SELECT':{
                let group = {...this.state.group}
                group.Users = action.users

                let selectUsersDialog = this.state.selectUsersDialog
                selectUsersDialog.open = false

                this.setState({selectUsersDialog: selectUsersDialog, group: group})
                break;
            }

            default:
                console.log('Undefined action case: '+action.type)
        }
        
    }

    handleDateFromChange(date){

        let group = {...this.state.group}
        group.DtEnd = date.getTime()
       
        //console.log('handleDateFromChange')
        //console.log(date)

        this.setState({group: group})

    }


    render(){
        const {t, i18n} = this.props

        const title = t('DynamicGroup')

        const margin = {margin:'16px 0 8px 0'}

        let dateFormat = getDateTimeFormat(i18n)

        let dtEndChecked = this.state.group.DtEnd || this.state.dtEndChecked ? true : false

        let dtEnd = this.state.group.DtEnd ? new Date(this.state.group.DtEnd) : new Date()
        //console.log('dtEnd')
        //console.log(dtEnd)
        //console.log('this.state.group.DtEnd')
       //console.log(this.state.group.DtEnd)
        

        //console.log('dtEndChecked')
        //console.log(dtEndChecked)

        let dtCreated = formatDateTime(this.state.group.DtCreated)

        return(
<Dialog
    scroll="body"
    fullWidth={this.props.fullWidth}
    maxWidth={this.props.maxWidth}
    open={this.props.open}
    onClose={this.handleClose.bind(this)}
    aria-labelledby="properties-dialog-title">

    {this.state.selectUsersDialog.open? (
                        <SelectUsersDialog open={this.state.selectUsersDialog.open}
                            networks={this.props.networks}
                            users={this.state.selectUsersDialog.users}
                            networkID={this.props.networkID}
                            onAction={this.handleAction} ></SelectUsersDialog>
                    ) : null }
        
    <DialogTitle id="properties-dialog-title">{title}</DialogTitle>
    <DialogContent>
        <form>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Container maxWidth="lg" style={{minWidth:300}}>

            <Box textAlign="">
                <TextField name="Name"  margin="normal"
                    style={{width: '100%'}}
                    label={this.state.errors.Name?this.state.errors.Name:t('Name')}
                    autoComplete="off"
                    error={this.state.errors.Name!==false}
                    value={this.state.group.Name}
                    onChange={this.handleInput.bind(this)}
                />
            </Box>

            <Box>
                <Checkbox color="primary" style={{marginTop:16}}
                    checked={dtEndChecked}
                    onChange={this.handleInput2}
                    name="dtEndChecked"
                />
                <KeyboardDateTimePicker
                        style={{marginRight: 16}}
                        margin="normal"
                        id="dateFrom"
                        name="dateFrom"
                        label={t('ExpiredDate')}
                        cancelLabel={t('Cancel')}
                        okLabel={t('Apply')}
                        format={dateFormat}
                        value={dtEnd}
                        onChange={this.handleDateFromChange}
                        disabled={!dtEndChecked}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                        />
            </Box>

            <Box>      
                <Grid container>
                    <Grid item xs={11} align="left">

                    <TextField
                        style={{width: '100%'}}
                        id="Members"
                        label={t('Members')}
                        multiline
                        variant="outlined"
                        rows={3}
                        InputProps={{readOnly: true}}
                        value={this.state.group.Users.map(item=>item.Name).join(', ')}
                    />

                    </Grid>
                    <Grid item xs={1} style={{verticalAlign:'bottom', paddingTop:8}}>

                        <IconButton onClick={this.openSelectUsersDialog}><MoreVert /></IconButton>

                    </Grid>
                </Grid>
            </Box>

            <Box style={{marginTop:16, fontSize: '0.9em'}}>
                
                {this.state.group.OwnerName ? 
                t('OwnerName')+': '+this.state.group.OwnerName+', '+t('Created')+': '+dtCreated
                : null}                
                
            </Box>
        
        </Container>
        </MuiPickersUtilsProvider>
        </form>
    </DialogContent>
    <DialogActions>
        <Button onClick={this.handleDelete.bind(this)} variant="contained" color="error" style={{marginRight:30}}>
            {t('RemoveGroup')}
        </Button>
        <Button onClick={this.handleSave.bind(this)} variant="contained" color="primary">
            {t('Apply')}
        </Button>
        <Button onClick={this.handleClose.bind(this)} variant="contained" color="inherit">
            {t('Cancel')}
        </Button>
    </DialogActions>

</Dialog>
        );

    }
}


export const DynamicGroupPropertiesDialog = withTranslation()(DynamicGroupPropertiesDialog_);